import { createSelector } from 'reselect'
import * as gameSelectors from '../game.selectors'
import * as preloaderSelectors from '../../Preloader/preloader.selectors'
import { buildUri } from '../../Preloader/preloader.helpers'
export const getAudios = createSelector(
  [gameSelectors.getAudiosPlaying, gameSelectors.getStoryLine, preloaderSelectors.getPreloaded],
  (audiosPlaying, storyLine, preloaded) => {
    const audios = Object.keys(audiosPlaying)
    return audios
      .filter((audioId) => !!storyLine.sounds[audioId])
      .map((audioId) => {
        const paused = audiosPlaying[audioId].paused
        const urlAudio = preloaded[audioId]
        const storyLineAudios = storyLine.sounds[audioId]
        return { ...storyLineAudios, url: urlAudio, paused: paused }
      })
  }
)
export const getOnlyAudio = createSelector(
  [gameSelectors.getStoryLine, preloaderSelectors.getPreloaded],
  (storyLine, preloaded) => {
    const audios = Object.keys(storyLine.commonPreload)
    return audios.map((audioId) => {
      // const urlAudio = '../../../../assets/trialMusic/Rock.mp3'
      const storyLineAudios = storyLine.commonPreload[audioId]
      // Use preloaded URL if available, otherwise build URL from commonPreload
      let urlAudio = preloaded[audioId]
      if (!urlAudio && storyLineAudios.url) {
        urlAudio = buildUri(storyLineAudios.url)
      }
      const autoplay = storyLineAudios.autoplay || true
      const loop = storyLineAudios.loop || false
      const type = storyLineAudios.type
      return { ...storyLineAudios, url: urlAudio, autoplay: autoplay, loop: loop, type: type }
    })
  }
)
export const getBackgroundHowlAudios = createSelector([], (audios) => {
  return audios
})
export const getBackgroundAudios = createSelector([getAudios], (audios) => {
  return audios.filter((elem) => elem.type === 'background')
})

export const getUrlAudio = createSelector(
  [gameSelectors.getStoryLine, preloaderSelectors.getPreloaded],
  (storyLine, preloaded) => {
    const audios = Object.keys(storyLine.commonPreload)
    return audios.map((audioId) => {
      const urlAudio = preloaded[audioId]
      const storyLineAudios = storyLine.sounds[audioId]
      return { ...storyLineAudios, url: urlAudio }
    })
  }
)
